import React, { useEffect, useState } from 'react';

const DEFAULT_MESSAGE = 'You do not currently have permission from your Organization Head or Organization Admin to access this feature.';

export default function PermissionDeniedToast() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    let timer = null;

    const onPermissionDenied = (event) => {
      const nextMessage = event?.detail?.message || DEFAULT_MESSAGE;
      setMessage(nextMessage);

      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        setMessage('');
      }, 4500);
    };

    window.addEventListener('ems:permission-denied', onPermissionDenied);
    return () => {
      window.removeEventListener('ems:permission-denied', onPermissionDenied);
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  if (!message) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-[80] max-w-md rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 shadow-lg">
      <p className="text-sm font-medium text-rose-700">{message}</p>
    </div>
  );
}
